




















import Vue from 'vue';

import Logo from '../components/Logo.vue';

export default Vue.extend({
	name: 'AuthView',
	components: {
		Logo,
	},
	props: {
		form: {
		},
		formLoading: {
			type: Boolean,
			default: false,
		},
		subtitle: {
			type: String,
		},
	},
	methods: {
		onInput(e: {name: string, value: string}) {
			this.$emit('input', e);
		},
		onSubmit(values: {[key: string]: string}) {
			this.$emit('submit', values);
		},
		onSecondaryClick() {
			this.$emit('secondaryClick');
		},
	},
});
